<template>
    <rkm-overlay>
        <rkm-layout-body title="Parametrização">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :key="formKey"
                    @data-load="handleDataLoaded"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/regulacao/parametrizacao/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    data: () => ({
        formKey: 1,
        data: null,
        unwatchers: {
            unwatchData: null
        }
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleDataLoaded(data) {

            this.data = data

            this.addDataWatcher()
        },
        addDataWatcher() {

            this.unwatchData = this.$watch('data', {
                deep: true,
                handler() {

                    this.setShowExitFormConfirmation()
                    this.unwatchData()
                }
            })
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()

            this.formKey++
        },
    },
}
</script>